// Product events for Google Analytics (through the xenquote GTM container).
//
// The shared consent script (https://xenquote.com/xq-consent.js, loaded from
// index.html) exposes window.xqConsent.track, which pushes the event to GTM's
// dataLayer; GTM's "GA4 event - xenquote events" tag sends the ones it knows
// (sign_up, login, tool_created, begin_checkout, purchase) to GA4, under Consent
// Mode, and the ad tags (marketing consent only) use sign_up and purchase as conversions.
//
// That script only runs on the prod console (app/console/portal.xenquote.com),
// so on dev and localhost this does nothing.
//
// NEVER put personal data in params: no emails, names, company or user ids.

type XqConsent = { track: (name: string, params?: Record<string, string | number | boolean>) => void };

export type TrackEvent = "sign_up" | "login" | "tool_created" | "begin_checkout" | "purchase";

export function track(name: TrackEvent, params?: Record<string, string | number | boolean>): void {
  try {
    (window as unknown as { xqConsent?: XqConsent }).xqConsent?.track(name, params);
  } catch {
    // analytics must never break the console
  }
}
